"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

var PauseIcon = function PauseIcon(_a, _b) {
  var theme = _b.theme;
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("rect", {
    x: "3.094",
    y: "2.685",
    width: "3.1",
    height: "10.63"
  }), React.createElement("rect", {
    x: "8.818",
    y: "2.685",
    width: "3.1",
    height: "10.63"
  })));
};

exports["default"] = PauseIcon;